export default {
    userInfo: state => state.user.userInfo,
    permissions: state => state.user.permissions
}



// WEBPACK FOOTER //
// ./src/store/getters.js